/* Nesti — comportamento das seções portadas do GemPages (substitui o runtime do app) */
(function () {
  function iniciar(raiz) {
    if (raiz.dataset.nestiPronto) return;
    raiz.dataset.nestiPronto = '1';
    var cfg = {};
    var estilos = {};
    try { var gd = JSON.parse(raiz.getAttribute('gp-data') || '{}'); cfg = gd.setting || {}; estilos = gd.styles || {}; } catch (e) {}
    var trilho = raiz.querySelector('.gem-slider');
    if (!trilho) return;
    var itens = Array.prototype.filter.call(trilho.children, function (c) { return c.classList.contains('gem-slider-item'); });
    var ant = raiz.querySelector('.gem-slider-previous');
    var prox = raiz.querySelector('.gem-slider-next');
    var pontos = Array.prototype.slice.call(raiz.querySelectorAll('.gp-carousel-dot-container button[data-index]'));
    var atual = 0;
    function celular() { return window.matchMedia('(max-width: 767px)').matches; }
    function porTela() {
      var n = cfg.itemNumber || {};
      if (celular()) return n.mobile || 1;
      if (window.matchMedia('(max-width: 1024px)').matches) return n.tablet || n.desktop || 1;
      return n.desktop || 1;
    }
    function emLaco() { var l = cfg.loop || {}; return celular() ? !!(l.mobile !== undefined ? l.mobile : l.desktop) : !!l.desktop; }
    function ultimo() { return Math.max(0, itens.length - porTela()); }
    function ir(i, suave) {
      var fim = ultimo();
      if (emLaco()) { if (i < 0) i = fim; if (i > fim) i = 0; }
      atual = Math.max(0, Math.min(i, fim));
      var alvo = itens[atual];
      trilho.scrollTo({ left: alvo ? alvo.offsetLeft - itens[0].offsetLeft : 0, behavior: suave === false ? 'auto' : 'smooth' });
      pontos.forEach(function (p, k) {
        var ativo = k === atual;
        p.style.backgroundColor = ativo ? 'var(--g-c-line-3, #121212)' : 'var(--g-c-bg-1, #e2e2e2)';
        p.setAttribute('aria-current', ativo ? 'true' : 'false');
        p.classList.toggle('gp-carousel-dot--active', ativo);
        p.classList.toggle('gem-slider-dot-active', ativo);
        p.classList.toggle('gem-slider-dot-inactive', !ativo);
      });
      raiz.dispatchEvent(new CustomEvent('nesti:slide', { detail: { indice: atual, item: alvo } }));
      if (!emLaco()) {
        if (ant) ant.style.visibility = atual === 0 ? 'hidden' : '';
        if (prox) prox.style.visibility = atual >= fim ? 'hidden' : '';
      } else {
        if (ant) ant.style.visibility = '';
        if (prox) prox.style.visibility = '';
      }
    }
    if (ant) ant.addEventListener('click', function (e) { e.preventDefault(); ir(atual - 1); });
    if (prox) prox.addEventListener('click', function (e) { e.preventDefault(); ir(atual + 1); });
    pontos.forEach(function (p) { p.addEventListener('click', function (e) { e.preventDefault(); ir(+p.dataset.index); }); });
    // arrasto / deslize: a rolagem nativa do trilho decide o item mais próximo
    var arrastoOk = function () { var d = cfg.enableDrag || {}; return celular() ? d.mobile !== false : !!d.desktop; };
    var x0 = null;
    trilho.addEventListener('touchstart', function (e) { if (arrastoOk()) x0 = e.touches[0].clientX; }, { passive: true });
    trilho.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) ir(atual + (dx < 0 ? 1 : -1));
    });
    // carrossel marcado com data-nesti-px (PDPs portadas do DOM renderizado): o app media o item
    // em px pela largura da janela do carrossel — itens por tela, espiada e espaçamento do gp-data
    function dispositivo() { var w = window.innerWidth; return w < 768 ? 'mobile' : (w < 1025 ? 'tablet' : 'desktop'); }
    function porDisp(o) {
      if (o == null || typeof o !== 'object') return o;
      var d = dispositivo();
      if (o[d] !== undefined) return o[d];
      if (d === 'mobile' && o.tablet !== undefined) return o.tablet;
      return o.desktop;
    }
    function dimensionar() {
      if (!raiz.hasAttribute('data-nesti-px')) return;
      var W = trilho.clientWidth;
      if (!W) return;
      var n = porDisp(cfg.itemNumber);
      var gap = parseFloat(porDisp(estilos.spacing)) || 0;
      itens.forEach(function (it, k) { it.style.marginRight = k < itens.length - 1 ? gap + 'px' : ''; it.style.transform = ''; });
      if (n === 'auto' || n == null) { itens.forEach(function (it) { it.style.minWidth = it.style.maxWidth = ''; }); return; }
      n = parseFloat(n) || 1;
      var espia = porDisp(cfg.sneakPeak);
      if (espia) {
        var centro = porDisp(cfg.sneakPeakType) === 'center';
        var off = parseFloat(porDisp(centro ? cfg.sneakPeakOffsetCenter : cfg.sneakPeakOffsetForward)) || 0;
        n = n + off / 100 * (centro ? -2 : -1);
      }
      var largura = (W - gap * (n - 1)) / n;   // como o slider do app: espaço proporcional aos itens por tela
      itens.forEach(function (it) { it.style.minWidth = it.style.maxWidth = largura + 'px'; it.style.height = ''; });
    }
    dimensionar();
    window.addEventListener('resize', function () { dimensionar(); ir(atual, false); });
    // quem está de fora (galeria do produto, troca de variante) move o carrossel por aqui
    raiz.nestiIr = function (i, suave) { ir(i, suave); };
    raiz.nestiItens = itens;
    ir(0, false);
  }
  function tudo() { document.querySelectorAll('gp-carousel').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo); else tudo();
  document.addEventListener('shopify:section:load', tudo);
})();
